export default __webpack_public_path__ + "static/media/iconLogo.791bda70.svg";